import { type FlowInsuranceCardBlockConfig, FlowInsuranceCardBlockConfigSchema } from 'flow-schema';

import { InsuranceCardFormFields } from './FormFields';
import { insuranceCardDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const insuranceCardNodeConfig: BlockConfigProps<FlowInsuranceCardBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'insuranceCard',
  defaultConfig: {
    gsPath: '',
  },
  configFields: {
    schema: FlowInsuranceCardBlockConfigSchema,
    FormFields: InsuranceCardFormFields,
  },
  documentationMarkdown: insuranceCardDocumentationMarkdown,
};
